import React from "react";

interface Person {
  id: string;
  name: string;
  about: JSX.Element[];
}

export function getEmployees(): Person[] {
  const employees: Omit<Person, "shuffle" | "not_first">[] = [
    {
      id: "dps",
      name: "David Singleton",
      about: [
        <p>David built smartphone OS software before smartphones were a thing. He worked on most of Google's early mobile experiences and founded Android Wear. For the last seven years he's been CTO at Stripe building and scaling economic infrastructure for the Internet and geeking out on developer experience.</p>,
        <p>David enjoys cooking, skiing, and tinkering with neural networks.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer" 
          href="https://blog.singleton.io"
        >
          blog.singleton.io
        </a>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/davidpsingleton"
        >
          linkedin.com/in/davidpsingleton
        </a>,
      ],
    },
    {
      id: "elizabeth",
      name: "Elizabeth Eastman",
      about: [
        <p>Elizabeth is an engineer who is passionate about the future of autonomous software. An MIT graduate, she previously led the recommendations ML team at Qloo. She is now channeling her love for coding agents into building the next generation of tools.</p>,
        <p>Outside of work, Elizabeth enjoys skiing, playing tennis, and doing anything outdoors.</p>,
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/elizabetheastmanqueenan">
          linkedin.com/in/elizabetheastmanqueenan
        </a>,
      ],
    },
    {
      id: "hbarra",
      name: "Hugo Barra",
      about: [
        <p>Hugo is a passionate student of computing history and has dedicated a career to working on the next major consumer waves — voice assistants, smartphones, VR & smartglasses, home diagnostics.</p>,
        <p>Originally from Brazil, he's lived in the US, UK, China & India and explored 82 countries (and counting). His desk is a permanent testing ground for prototype hardware and new gadgets. Hugo is a proud husband and father of two.</p>,
        <a target="_blank" rel="noopener noreferrer" href="https://hugo.blog/">
          hugo.blog
        </a>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/hbarra/"
        >
          linkedin.com/in/hbarra/
        </a>,
      ],
    },
    {
      id: "jake",
      name: "Jake Slack",
      about: [
        <p>Jake builds digital ecosystems, and comes from doing that for a decade with Google.</p>,
        <p>Besides building the future, you will find Jake on the slopes, enjoying fresh pow.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/jacobslack/"
        >
          linkedin.com/in/jacobslack/
        </a>,
      ],
    },
    {
      id: "johan",
      name: "Johan Duramy",
      about: [
        <p>From launching new products at Google to helping startups scale at CapitalG, Johan loves building and scaling — teams, systems, and products that turn ambitious ideas into reality.</p>,
        <p>Originally from France, he loves cooking (worked in an Italian restaurant), swimming in the cold of the SF Bay, and improving pottery skills learned while living in Kyoto.</p>,
        <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://linkedin.com/in/johanduramy"
      >
        linkedin.com/in/johanduramy
      </a>,
      ],
    },
    {
      id: "josh",
      name: "Josh Estelle",
      about: [
        <p>Josh loves building things that feel magical but work at scale. He spent two decades at Google – breaking language barriers with Translate, scaling beautiful experiences with Material Design, and bringing LLMs into Search, happiest when turning complex technology into delightful products.</p>,
        <p>You’ll also find him making things, making music, riding electric toys, dancing, and playing in the ocean.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer" 
          href="https://joshestelle.com"
        >
          joshestelle.com
        </a>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/joshestelle/"
        >
          linkedin.com/in/joshestelle/
        </a>,
      ],
    },
    {
      id: "justin",
      name: "Justin Belcher",
      about: [
        <p>Justin is a builder at heart, obsessed with crafting tools that expand what's possible.</p>,
        <p>He spent the last decade at Google as a design lead on Material Design, bringing together multiple teams to pioneer new ways of creating and rationalizing beautiful experiences at scale.</p>,
        <p>When not drawing rectangles, you can find him{" "}<a target="_blank" rel="noopener noreferrer" href="https://onend.studio/">building furniture</a>, dispensing great SF recs, and trying to convince his two senior dogs that not everything is edible.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/justinrbelcher/"
        >
          linkedin.com/in/justinrbelcher
        </a>,
      ],
    },
    {
      id: "nj",
      name: "Nicholas Jitkoff",
      about: [
        <p>Nicholas loves creating digital experiences that make action feel effortless{" "}<a target="_blank" rel="noopener noreferrer" href="https://itty.bitty.site/#/eJyN00+LEzEUAPB7P8U7iR62o1Q8tGFA9qon+wXSmcwkNE1K8koZRSile6ogRShi92DZSvVW2UWlVv0wO+mwp/0K0j+Wbbt0vb68/PJ4L49YTCTzcwAYFiNhLB4FXMgQXuUAAHSdBgKTIjzMPy4tI3UahkLFR0bEHIvwiNUW8dc54q0lEjCFzPg5grSyogkan3ho/KVAMPQJL/hlqqHM4JgLFROPFxYp4XbKk8LWwT+D3KSy9jTrDLP29Hr2Zlt4GiA0BXLdQAi1UHHpIJROu1lnmE67e1BTm+pGYlGkDeYPUq53nnWGrnd+2Wq70dhN3rrRBzfp7cllLlQVdATIGdgalRKoBUlNzA4/8PHrvPU5/fnJ/f5+2Wpvo1SFSy9izYVWoyq5o9zT/tXgbN6fuZNv8/fv9qo81ioyWuFSDUUUiaAh8a6puNF4RWYXk+vZYKelXEgGAkFYsCikBEZtcnhAbvQl/dG9Gpyl0677c5L+Op33Z7fVS4NA1+pSWL6sODaMIiC11f/g3Wh8k88uJnv9rSRAwTIjmF2Mbj22AO3hLt9TFVsv7XzyWy7sbIrwny0W5WWDeGKVvw7fR0OVlRSFVlBJ4EUengsMOJPywSZ3YxNvvY7EWy/oX2fgZcc=" style={{fontWeight: 300, fontSize: "80%", color: "var(--dim-text-color)"}}>&#x70BA;&#x7121;&#x70BA;</a></p>,
        <p>From OS design at Google and Meta to productivity at Dropbox and Figma, he's brought together teams to build software that empowers people in new and delightful ways.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://nicholas.jitkoff.com/"
        >
          nicholas.jitkoff.com
        </a>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/jitkoff/"
        >
          linkedin.com/in/jitkoff
        </a>,
      ],
    },
    {
      id: "pal",
      name: "Pál Takácsi",
      about: [
        <p> Pál is a software engineer focused on building scalable systems and applying generative AI to solve real-world problems.</p>,
        <p> Outside work, he spends his time skiing steep lines, sailing whenever he can, and logging long days on the mountain bike.</p>,
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/pal-takacsi-nagy-659b51/">linkedin.com/in/pal-takacsi-nagy-659b51</a>,
      ],
    },
    {
      id: "rui",
      name: "Rui Xu",
      about: [
        <p> Rui builds things that move — and the teams that move fast. From the early days of smartphones to smart TVs, from AI devices to humanoid robots, he thrives where hardware, software, and human interaction meet. He blends engineering rigor with product intuition, turning ideas into products that work — in the factory and in the world.</p>,
        <p> Outside the lab, he’s a devoted dad, weekend cook, and habitual tinkerer — equally at home teaching Romance of the Three Kingdoms in Classical Chinese to his daughter or perfecting sugar-coated fruit for her school fair. </p>,
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/ruixu/">linkedin.com/in/ruixu</a>,
      ],
    },
    {
      id: "sara",
      name: "Sara Rowghani",
      about: [
        <p>Sara is a creative problem-solver who builds brands and experiences that make people's lives a little easier—and hopefully a lot more fun.</p>,
        <p>When she's not crafting strategy, she's crafting furniture, throwing around heavy weights, or hiking in the wilderness. She's never met a dad joke she didn't like, which is pun-ishing all of us.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/sararowghani"
        >
          linkedin.com/in/sararowghani
        </a>,
      ],
    },
    {
      id: "sascha",
      name: "Sascha Häberling",
      about: [
        <p>Sascha is a software engineer who is passionate about building delightful user experiences. He enjoys working across the full stack, from crafting snappy UIs and fast backends to occasionally programming microcontrollers.</p>,
        <p>For nearly 18 years at Google as an Engineer and Manager, he helped pioneer never-done-before products and features from within Search, Maps, Android and Google Beam.</p>,
        <p>In his free time, he enjoys 3D printing, riding his bike and creating music.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/haberling/"
        >
          linkedin.com/in/haberling
        </a>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://saschah.com/"
        >
          saschah.com
        </a>,
      ],
    },
    {
      id: "srikanth",
      name: "Srikanth Chinmay",
      about: [
        <p>With two decades of experience across Stripe, Google, and NASA, Srikanth is a relentless builder and operator. He cares deeply about enabling users and developers with delightful experiences.</p>,
        <p>Outside of work, he loves going deep on all things history, finding ways to be on tennis courts when possible and is exploring ways to get back to playing the violin.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/srikanthchinmay/"
        >
          linkedin.com/in/srikanthchinmay
        </a>
      ],
    },
    {
      id: "travis",
      name: "Travis Collins",
      about: [
        <p>Travis is an engineer who loves working across the stack and doesn't neglect the finer details. After 7 years at Google working on everything from mobile payments to Android and web components for Material Design, he created and ran an open source platform for playing competitive StarCraft.</p>,
        <p>Beyond work, Travis enjoys photography (especially infrared), competitive games, and spending time with his two cats.</p>,
        <a target="_blank" rel="noopener noreferrer" href="https://tec27.com">tec27.com</a>,
      ],
    },
    {
      id: "tucker",
      name: "Tucker Wieland",
      about: [
        <p>Tucker works across marketing and growth operations, building systems that help products and communities thrive. He focuses on clarity, thoughtful measurement, and making sure great ideas reach the people they're meant for.</p>,
        <p>Outside of work, he's usually near the water, on a bike, or somewhere in nature, staying involved in water quality initiatives and environmental stewardship.</p>,
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/tucker-wieland"
        >
          linkedin.com/in/tucker-wieland
        </a>,
      ],
    },
    {
      id: "zak",
      name: "Zak Cohen",
      about: [
        <p>Zak is an engineer who has always been fascinated with how new products can emerge from the frontiers of technology. Eighteen years at Google had him working on novel projects across photos, mobile, video editing, watches, VR and more.</p>,
        <p>Outside of work, Zak enjoys cooking, snowboarding and listening to - and making - noisy music.</p>,
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/zakcohen/">linkedin.com/in/zakcohen</a>,
      ],
    },
  ];

  return [
    ...employees,
    {
      id: "rachel",
      name: "Rachel Eizner",
      about: [
        <p>Rachel grew up on the internet and has a soft spot for niche, playful corners of the web. An engineer by education and an extrovert by nature, she's on a mission to bring people together (online & in-person) and make every interaction a bit more delightful. If found, please return to Berkeley Bowl, her last Wikipedia rabbit-hole, or wherever her friends are.</p>,
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/eizner/">linkedin.com/in/eizner</a>,
      ],
    },
    {
      id: "you?",
      name: "",
      about: [
        <p>Try <b>jobs</b> :-)</p>,
      ],
    },
  ];
}
